var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStats(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74951 1.99463C3.16373 1.99463 3.49951 2.33042 3.49951 2.74463V16.4955H17.2504C17.6646 16.4955 18.0004 16.8313 18.0004 17.2455C18.0004 17.6597 17.6646 17.9955 17.2504 17.9955H2.74951C2.3353 17.9955 1.99951 17.6597 1.99951 17.2455V2.74463C1.99951 2.33042 2.3353 1.99463 2.74951 1.99463Z",
    fill: "#676879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3741 6.7513L14.0224 6.75131C13.6082 6.75131 13.2724 6.41553 13.2724 6.00131C13.2724 5.5871 13.6082 5.25131 14.0224 5.25131L16.9912 5.25128C17.1901 5.25128 17.3809 5.3303 17.5216 5.47095C17.6622 5.6116 17.7412 5.80237 17.7412 6.00128V8.99954C17.7412 9.41375 17.4055 9.74954 16.9912 9.74954C16.577 9.74954 16.2412 9.41375 16.2412 8.99954V8.04874L12.1045 12.9376C11.747 13.3602 11.077 13.2935 10.8097 12.8089L8.94413 9.42701L6.62183 12.9133C6.3922 13.258 5.92658 13.3513 5.58185 13.1217C5.23711 12.8921 5.14381 12.4264 5.37344 12.0817L8.3717 7.58067C8.38534 7.56018 8.39999 7.54038 8.41558 7.52134C8.75819 7.10288 9.41418 7.16682 9.67098 7.63914L11.6252 11.1818L15.3741 6.7513Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.dc5d94fa.svg";
export { ForwardRef as ReactComponent };